import { Col, Flex, Form, Grid } from "antd";
import { useTranslation } from "react-i18next";
import Clock from "../../../../../../assets/images/icons/Clock";
import LocationDemo from "../../../../../../assets/images/icons/LocationDemo";
import SkiDemo from "../../../../../../assets/images/icons/SkiDemo";
import UserDemo from "../../../../../../assets/images/icons/UserDemo";
import {
  CountDropdown,
  ResortDropdown,
  SessionTypeSelector,
  SkillSelector,
} from "../../../../../../components";
import { InputRequired } from "../../../../../../validations/validations";
import { FilterProps } from "../../data";

const OtherFilter: React.FC<FilterProps> = ({
  form,
  params,
  setParams,
  showHalfDaySelector,
  setShowHalfDaySelector,
  studentLimit,
  setStudentLimit,
}) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <>
      <Col span={screens.lg ? (showHalfDaySelector ? 12 : 8) : 12}>
        <Flex
          align="center"
          gap={12}
          style={{ marginBottom: screens.sm ? 12 : 0 }}
        >
          <LocationDemo
            style={{
              fontSize: screens.sm ? 32 : 20,
              color: "var(--Neutral-dark-50)",
              minWidth: screens.sm ? 32 : 20,
            }}
          />
          <Form.Item
            style={{ marginBottom: 0, flex: 1 }}
            name={"locations"}
            label={t("home.searchbar.resort.title")}
            rules={[InputRequired(t, "home.searchbar.resort.title")]}
            className="filter-form-item"
          >
            <ResortDropdown
              form={form}
              setShowHalfDaySelector={setShowHalfDaySelector}
              setStudentLimit={setStudentLimit}
            />
          </Form.Item>
          {/* <Divider
            type="vertical"
            style={{
              height: "24px",
            }}
          /> */}
        </Flex>
      </Col>
      {showHalfDaySelector && (
        <Col span={12}>
          <Flex align="center" gap={12}>
            <Clock
              style={{
                fontSize: screens.sm ? 32 : 20,
                color: "var(--Neutral-dark-50)",
                minWidth: screens.sm ? 32 : 20,
              }}
            />
            <Form.Item
              style={{ marginBottom: 0, flex: 1 }}
              name={"session_type"}
              label={t("normal.sessionType")}
              rules={[InputRequired(t, "normal.sessionType")]}
              className="filter-form-item"
            >
              <SessionTypeSelector form={form} />
            </Form.Item>
          </Flex>
        </Col>
      )}
      <Col span={screens.lg ? (showHalfDaySelector ? 12 : 8) : 12}>
        <Flex align="center" gap={12}>
          <SkiDemo
            style={{
              fontSize: screens.sm ? 32 : 20,
              color: "var(--Neutral-dark-50)",
              minWidth: screens.sm ? 32 : 20,
            }}
          />
          <Form.Item
            style={{ marginBottom: 0, flex: 1 }}
            name={"skill_type"}
            label={t("normal.skill.title")}
            rules={[InputRequired(t, "normal.skill.title")]}
            className="filter-form-item"
          >
            <SkillSelector form={form} />
          </Form.Item>
          {/* {(screens.lg || (!screens.lg && showHalfDaySelector)) && (
            <Divider
              type="vertical"
              style={{
                height: "24px",
              }}
            />
          )} */}
        </Flex>
      </Col>
      <Col span={screens.lg ? (showHalfDaySelector ? 12 : 8) : 12}>
        <Flex align="center" gap={12}>
          <UserDemo
            style={{
              fontSize: screens.sm ? 32 : 20,
              color: "var(--Neutral-dark-50)",
              minWidth: screens.sm ? 32 : 20,
            }}
          />
          <Form.Item
            name={"count"}
            required
            label={t("normal.count.title")}
            style={{ marginBottom: 0, flex: 1 }}
            className="filter-form-item"
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (
                    Number(getFieldValue("adults")) === 0 &&
                    Number(getFieldValue("kids")) === 0
                  )
                    return Promise.reject(
                      new Error(
                        t("form.required", { name: t("normal.count.title") })
                      )
                    );
                  return Promise.resolve();
                },
              }),
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (
                    Number(getFieldValue("adults")) +
                      Number(getFieldValue("kids")) >
                    studentLimit
                  ) {
                    return Promise.reject(
                      new Error(
                        t("home.filter.count.error", { limit: studentLimit })
                      )
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <CountDropdown
              form={form}
              params={params}
              setParams={setParams}
              studentLimit={studentLimit}
            />
          </Form.Item>
        </Flex>
        <Form.Item hidden name={"adults"} />
        <Form.Item hidden name={"kids"} />
      </Col>
    </>
  );
};

export default OtherFilter;
